import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '../sportsbook-root-selectors';
import {
	connectToBettingServiceRsocketClient,
	disconnectFromBettingServiceRsocketClient,
	updateBettingSessionExpirationInRsocketClient
} from '../api/sportsbook-api';
import { selectBettingSessionExpiresOn } from '../api/sportsbook-api-duck';

const useInitializeBettingServiceRsocketConnection = () => {
	const isUserAuthenticatedInApp = useSelector(selectIsAuthenticated);
	const bettingSessionExpiresOn = useSelector(selectBettingSessionExpiresOn);

	useEffect(() => {
		if (!isUserAuthenticatedInApp) {
			return;
		}

		void connectToBettingServiceRsocketClient();

		return () => {
			disconnectFromBettingServiceRsocketClient();
			updateBettingSessionExpirationInRsocketClient(null);
		};
	}, [isUserAuthenticatedInApp]);

	useEffect(() => {
		if (!isUserAuthenticatedInApp) {
			return;
		}

		updateBettingSessionExpirationInRsocketClient(bettingSessionExpiresOn);
	}, [isUserAuthenticatedInApp, bettingSessionExpiresOn]);
};

export default useInitializeBettingServiceRsocketConnection;
